import * as _ from 'lodash';
import moment from 'moment';
import * as XLSX from 'xlsx';

export const startsWith = (sourceStr, search_string) => {
  if (!search_string) {
    return true;
  }

  return (sourceStr || '').toLowerCase().indexOf(search_string.toLowerCase()) >= 0;
};

export const millisecondsToHourMinute = (value) => {
  const d = moment.duration(value, 'milliseconds');
  const hours = Math.floor(d.asHours());
  const minute = Math.floor(d.asMinutes()) - hours * 60;
  return hours + ':' + minute;
};

export const millisecondsToHourMinuteSeconds = (value) => {
  const d = moment.duration(value, 'milliseconds');
  const hours = Math.floor(d.asHours());
  const minute = Math.floor(d.asMinutes()) - hours * 60;
  const seconds = Math.floor(d.asSeconds()) - minute * 60;
  return hours + ':' + minute + ':' + seconds;
};

export const roundOfDigit = (value, digit) => {
  return value === '-' ? value : _.round(value, digit).toFixed(2);
};

export const formatAmount = (value) => {
  if (value === '-' || typeof value == 'string') {
    return value
  }
  return value.toFixed(2)
}

/*
  * function for  parsing units and to arrange in a proper format to display it in table 
  * (currently used in invoicing report)
  * value: string | number | float
  * 
*/
export const formatNumber = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value.toFixed(2);
  }
  else if (typeof value === 'string' && !isNaN(parseFloat(value)) && isFinite(value)) {
    return parseFloat(value).toFixed(2);
  }
  else {
    return '';
  }
};

export const convertSeconds = (totalSeconds) => {
  const seconds = Math.floor(totalSeconds);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return `${hours}:${minutes}:${remainingSeconds}`;
};

export const getCustomerName = (item, defaultText = 'Guest User') => {
  const customer = _.get(item, 'customer_user_booked');

  if (typeof customer === 'undefined' || customer === null || _.isEmpty(customer)) {
    return defaultText;
  }

  const firstName = _.get(customer, 'first_name') || '';
  const lastName = _.get(customer, 'last_name') || '';
  const fullName = `${firstName} ${lastName}`.trim();
  if (fullName) return fullName;

  return _.get(customer, 'name') || defaultText;
};

const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : '');
const yesNo = (value) => (value ? 'Yes' : 'No');

// CDB-1862 — every vehicle on a customer / fleet profile, one row each.
export const downloadVehiclesExcel = (vehicles, fileName) => {
  const rows = _.map(vehicles, (vehicle, index) => ({
    'Sr No': index + 1,
    Name: _.get(vehicle, 'name', ''),
    Make: _.get(vehicle, 'make', ''),
    Model: _.get(vehicle, 'model', ''),
    Type: _.get(vehicle, 'type', ''),
    Year: _.get(vehicle, 'year', ''),
    'RTO No': _.get(vehicle, 'rto_no') || _.get(vehicle, 'rto_num') || '',
    'VIN No': _.get(vehicle, 'vin_num', ''),
    'Ownership Type': _.get(vehicle, 'ownership_type', ''),
    'Max Charging Capacity': _.get(vehicle, 'max_charging_capacity', ''),
    'Insurance Expiry': formatDate(_.get(vehicle, 'insurance_expiry')),
    Default: yesNo(_.get(vehicle, 'is_default')),
    Sessions: _.get(vehicle, 'session_count', ''),
    'Units Consumed': _.get(vehicle, 'unit_consumed', ''),
    ..._.fromPairs(
      _.flatMap(['', '_2', '_3', '_4', '_5'], (suffix, i) => [
        [`EVCC ID Gun ${i + 1}`, _.get(vehicle, `evcc_id${suffix}`) || ''],
        [`EVCC ID Gun ${i + 1} Saved On`, formatDate(_.get(vehicle, suffix ? `evcc_id${suffix}_save_date` : 'evccid_save_date'))],
      ])
    ),
    'AutoCharge Supported': yesNo(_.get(vehicle, 'is_autocharge_supported')),
    'AutoCharge Enabled': yesNo(_.get(vehicle, 'is_autocharge_enabled')),
    'AutoCharge Enabled On': formatDate(_.get(vehicle, 'autocharge_enabled_date')),
    'Dealer Vehicle': yesNo(_.get(vehicle, 'is_dealer_vehicle')),
    'Dealer Name': _.get(vehicle, 'dealer_credit.dealer_name', ''),
    'Dealer Credit Status': _.get(vehicle, 'dealer_credit.status', ''),
    'Dealer MAC ID': _.get(vehicle, 'dealer_credit.verified_evcc_id', ''),
  }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), 'Vehicles');
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
